import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../context/I18nContext';

const Footer = () => {
  const { t } = useI18n();

  return (
    <footer className="bg-amber-900 text-amber-100 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="text-2xl">🐾</span>
              <span className="text-xl font-bold font-serif">Paws Eternal</span>
            </div>
            <p className="text-amber-200 text-sm leading-relaxed">
              {t('footer.description')}
            </p>
          </div>
          <div>
            <h3 className="font-semibold mb-4 text-amber-50">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2 text-sm text-amber-200">
              <li><Link to="/" className="hover:text-white transition-colors">{t('nav.home')}</Link></li>
              <li><Link to="/products" className="hover:text-white transition-colors">{t('nav.shop')}</Link></li>
              <li><Link to="/cart" className="hover:text-white transition-colors">{t('nav.cart')}</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold mb-4 text-amber-50">{t('footer.info')}</h3>
            <ul className="space-y-2 text-sm text-amber-200">
              <li><a href="#about" className="hover:text-white transition-colors">{t('footer.about')}</a></li>
              <li><a href="#contact" className="hover:text-white transition-colors">{t('footer.contact')}</a></li>
              <li><span className="text-amber-300">{t('footer.freeShipping')}</span></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-amber-700 mt-8 pt-8 text-center text-sm text-amber-300">
          <p>{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
